import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext } from "react";
import { Route, Routes } from "react-router-dom";
export const DebugContext = createContext(false);
export default function WithDebug(props) {
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "debug/*", element: _jsx(DebugContext.Provider, { value: true, children: props.children }) }), _jsx(Route, { path: "nodebug/*", element: _jsx(DebugContext.Provider, { value: false, children: props.children }) }), _jsx(Route, { path: "*", element: _jsx(DebugContext.Provider, { value: props.defaultDebug, children: props.children }) })] }));
}
